import type { ApolloError, MutationResult } from '@apollo/client';
import type { ServerParseError } from '@apollo/client/link/http';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import MutationProgressDialog from '../../components/MutationProgressDialog';
import MutationSuccessMessage from '../../components/MutationSuccessMessage';

interface Props {
    mutationResult: MutationResult;
    finishedMessage: React.ReactNode;
}

const AppAlertProgress: React.FC<Props> = ({ mutationResult, finishedMessage }) => (
    <MutationProgressDialog
        mutationResult={mutationResult}
        finishedDialogContent={(
            <MutationSuccessMessage link="/maintenance">
                {finishedMessage}
            </MutationSuccessMessage>
        )}
        customErrorMessage={customErrorMessage}
    />
);

function customErrorMessage(error: ApolloError) {
    return (error.networkError as ServerParseError | null)?.statusCode === 413 && (
        <FormattedMessage id="app-alert.alert-too-big-error" />
    );
}

export default AppAlertProgress;
